import { useSelector } from "react-redux";
import { Series } from "remotion";
import {
  GetAudioState,
  GetFps,
  GetHandleAudio,
  GetOrderedActionsList,
} from "../../Redux/Reducers/redux-slice-timetool";
import { PausableVideo } from "./PausableVideo";
import { Premount } from "./premount";

export const PHANTOM_OFFSET_IN_SEC = 5;

export const VideoSequence: React.FC = () => {
  const orderedActionsList = useSelector(GetOrderedActionsList);
  const fps = useSelector(GetFps);
  const audioState = useSelector(GetAudioState);
  const handleAudio = useSelector(GetHandleAudio);

  return (
    // TODO: fps management
    <Series>
      {orderedActionsList
        .filter((x) => x.end - x.start >= 0)
        .map((x, i) => (
          <Series.Sequence
            offset={x.data.src !== "" ? Math.round(-PHANTOM_OFFSET_IN_SEC * fps) : 0}
            durationInFrames={
              x.data.src !== ""
                ? Math.round((x.end - x.start + PHANTOM_OFFSET_IN_SEC) * fps)
                : Math.round((x.end - x.start) * fps)
            }
            key={i}
            style={{ display: "flex", justifyContent: "center" }}
          >
            {x.data.src !== "" ? (
              <Premount for={x.data?.fps ? Math.round(PHANTOM_OFFSET_IN_SEC * fps) : 0}>
                <PausableVideo
                  channelToPlay={
                    x.data.audioMapping &&
                    audioState &&
                    audioState.trackIndex !== undefined &&
                    audioState.trackIndex !== null &&
                    handleAudio &&
                    x.data.audioMapping[audioState.trackIndex]
                  }
                  startFrom={x.data?.offSet || 0}
                  src={x.data.src}
                  fps={fps}
                  videoFps={x.data?.fps || fps}
                  actionId={x.data.actionId ?? ""}
                />
              </Premount>
            ) : (
              <></>
            )}
          </Series.Sequence>
        ))}
    </Series>
  );
};
